<template>
  <div v-if="editValue">
    <div v-if="!edit">
      <v-list-item v-if="!noname"
                   class="px-2">
        <v-list-item-content class="imitationpadding">
          <v-list-item-subtitle class="labeltext pl-3 pt-1"
                                v-text="nameLabel" />
          <v-list-item-title v-text="editValue.Name"
                             class="valuetext pl-3 pb-2" />
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="px-2">
        <v-list-item-content class="imitationpadding">
          <v-list-item-subtitle class="labeltext pl-3 pt-1"
                                v-text="countryLabel" />
          <v-list-item-title v-text="editValue.Country"
                             class="valuetext pl-3 pb-2" />
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="px-2">
        <v-container class="pa-0">
          <v-row no-gutters>
            <v-col cols="4">
              <v-list-item-content class="imitationpadding">
                <v-list-item-subtitle class="labeltext pl-3 pt-1"
                                      v-text="zipLabel" />
                <v-list-item-title v-text="editValue.Zip"
                                   class="valuetext pl-3 pb-2" />
              </v-list-item-content>
            </v-col>
            <v-col cols="8">
              <v-list-item-content class="imitationpadding">
                <v-list-item-subtitle class="labeltext pl-3 pt-1"
                                      v-text="cityLabel" />
                <v-list-item-title v-text="editValue.City"
                                   class="valuetext pl-3 pb-2" />
              </v-list-item-content>
            </v-col>
          </v-row>
        </v-container>
      </v-list-item>
      <v-list-item class="px-2">
        <v-list-item-content class="imitationpadding">
          <v-list-item-subtitle class="labeltext pl-3 pt-1"
                                v-text="streetLabel" />
          <v-list-item-title v-text="editValue.Street"
                             class="valuetext pl-3 pb-2" />
        </v-list-item-content>
      </v-list-item>
    </div>

    <v-list-item v-else
                 class="px-1">
      <v-container fluid>
        <v-row v-if="!noname">
          <v-col cols="12">
            <v-text-field v-model="editValue.Name"
                          :rules="rule"
                          :label="nameLabel"
                          hide-details="auto"
                          outlined
                          dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="editValue.Country"
                          :rules="rule"
                          :label="countryLabel"
                          hide-details="auto"
                          outlined
                          dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field v-model="editValue.Zip"
                          :rules="rule"
                          :label="zipLabel"
                          hide-details="auto"
                          outlined
                          dense />
          </v-col>
          <v-col cols="8">
            <v-text-field v-model="editValue.City"
                          :rules="rule"
                          :label="cityLabel"
                          hide-details="auto"
                          outlined
                          dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="editValue.Street"
                          :rules="rule"
                          :label="streetLabel"
                          hide-details="auto"
                          outlined
                          dense />
          </v-col>
        </v-row>
      </v-container>
    </v-list-item>
  </div>
</template>


<script>
import rules from "@/helpers/Mixins/RuleMixin.js";

export default {
  name: "AdressListItem",
  props: ["keyname", "value", "edit", "noempty", "noname"],
  mixins: [rules],

  data: () => ({ editValue: null, emitStack: [] }),

  mounted() {
    this.editValue = this.value;
    this.emitValue();
  },

  methods: {
    //Method that bundles changes and emits the final value,
    //  after a set amount of time after final change.
    popEmitStack() {
      if (this.emitStack.length > 1) {
        this.emitStack.pop();
        setTimeout(() => this.popEmitStack(), 500);
      } else if (this.emitStack.length === 1) {
        this.emitStack.pop();
        this.emitValue();
      }
    },
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },
    nameLabel() {
      return this.$t("servicesystem.common_objects.address.name");
    },
    countryLabel() {
      return this.$t("servicesystem.common_objects.address.country");
    },
    zipLabel() {
      return this.$t("servicesystem.common_objects.address.zip");
    },
    cityLabel() {
      return this.$t("servicesystem.common_objects.address.city");
    },
    streetLabel() {
      return this.$t("servicesystem.common_objects.address.street");
    },
  },

  watch: {
    //Set editvalue when value changes
    value: {
      deep: true,
      handler() {
        this.editValue = this.value;
      },
    },
    //Ques emit of edited value on change
    editValue: {
      deep: true,
      handler() {
        this.emitStack.push(1);
        this.emitStack.push(2);
        this.popEmitStack();
      },
    },
  },
};
</script>

<style scoped>
.imitationpadding {
  padding-top: 3px;
  padding-bottom: 2px;
}
.error--text {
  margin-bottom: -8px !important;
}
.labeltext {
  font-size: 12px !important;
  margin-bottom: 1px !important;
}
.valuetext {
  font-size: 13px !important;
  white-space: normal;
}
</style>